// 月子中心路由
var yzzx = [
	{// PC
		path: '/yzzx',
		name: 'yzzxHome',
		meta: {
			title: '月子中心'
		},
		component: () => import('@/views/yzzx/home')
	},
	
	{// 移动
		path: '/yzzx/m',
		name: 'yzzxm',
		redirect: '/yzzx/m/home',
		meta: {
			title: '月子中心'
		}
	},
	{// 首页
		path: '/yzzx/m/home',
		name: 'yzzxmHome',
		meta: {
			title: '月子中心'
		},
		component: () => import('@/views/yzzx/m/home')
	}
];

export default yzzx;